import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const { Option } = Select;

const PlanningForm = () => {
    const [fiscalYears, setFiscalYears] = useState([]);
    const [munWards, setMunWards] = useState([]);
    const [planningCategories, setPlanningCategories] = useState([]);

    useEffect(() => {
        // Fetch fiscal years
        axios
            .get('https://ward3-chandrapur-api.palikaapp.com/api/fiscal-year/all')
            .then((response) => setFiscalYears(response.data))
            .catch((error) => console.error('Error fetching fiscal years:', error));

        // Fetch municipal wards
        axios
            .get('https://ward3-chandrapur-api.palikaapp.com/api/ward/all')
            .then((response) => setMunWards(response.data))
            .catch((error) => console.error('Error fetching municipal wards:', error));

        // Fetch planning categories
        axios
            .get('https://ward3-chandrapur-api.palikaapp.com/api/planning/planning-category')
            .then((response) => setPlanningCategories(response.data))
            .catch((error) => console.error('Error fetching planning categories:', error));
    }, []);

    const onFinish = (values) => {
        axios
            .post('https://ward3-chandrapur-api.palikaapp.com/api/planning/save', {
                title: values.title,
                description: values.description,
                budget: values.budget,
                fiscalYear: values.fiscalYear,
                munWard: values.munWard,
                planningCategories: values.planningCategories,
            })
            .then(() => {
                message.success('Planning document added successfully!');
            })
            .catch((error) => {
                message.error('Failed to add planning document.');
                console.error('Error:', error);
            });
    };

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
            {/* Sidebar */}
           
                <Header />
                <div className="lg:w-1/5 pt-20">
                <Sidebar />
            </div>

            {/* Form Section */}
            <div className="lg:w-4/5 p-6 pt-20 mt-5">
                <h2 className="text-xl lg:text-2xl font-bold mb-6 text-center lg:text-center">
                    योजना थपगर्ने फार्म
                </h2>
                <div className="flex justify-center">
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        className="w-full max-w-md bg-white p-6 shadow-lg rounded-md"
                    >
                        <Form.Item
                            label="Title"
                            name="title"
                            rules={[{ required: true, message: 'Please input the title!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Description"
                            name="description"
                            rules={[{ required: true, message: 'Please input the description!' }]}
                        >
                            <Input.TextArea className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Budget"
                            name="budget"
                            rules={[{ required: true, message: 'Please input the budget!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Fiscal Year"
                            name="fiscalYear"
                            rules={[{ required: true, message: 'Please select the fiscal year!' }]}
                        >
                            <Select className="border-gray-300 rounded-md">
                                {fiscalYears.map((year) => (
                                    <Option key={year.id} value={year.id}>
                                        {year.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="वडा"
                            name="munWard"
                            rules={[{ required: true, message: 'Please select the municipal ward!' }]}
                        >
                            <Select className="border-gray-300 rounded-md">
                                {munWards.map((ward) => (
                                    <Option key={ward.id} value={ward.id}>
                                        {ward.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Planning Categories"
                            name="planningCategories"
                            rules={[{ required: true, message: 'Please select the planning categories!' }]}
                        >
                            <Select className="border-gray-300 rounded-md">
                                {planningCategories.map((category) => (
                                    <Option key={category.id} value={category.id}>
                                        {category.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default PlanningForm;
